$(() => {
  const key = 'data-disable-on-checked';
  $(`[${key}=main]`).on('change', function() {
    $(`[${key}=sub]`).prop('disabled', $(this).prop('checked'));
  });
});
